<template>
  <div class="signature-form">
    <header style="background-color: #F8F6F0">
      <img style="margin-right: 1em;" alt="Vantor" width="185"
        src="https://cdn.sanity.io/images/ava0h2e5/production/a04cd2af1440e467e8ad9d2330a7e360d7124fec-2400x544.png" />
      <h1 style="color:black">Email Signature Tool</h1>
    </header>
    <section class="content">
      <div class="form-area">
        <div class="button-area">
          <div class="info-btn-div" @click="seen = !seen"></div>
          <img v-if="!seen" class="info-btn" src="@/assets/informationBlack.svg" @click="seen = !seen" />
          <img v-if="seen" class="close-btn" src="@/assets/close-icon.svg" @click="seen = !seen" />
        </div>
        <div v-if="seen" class="inline-modal">
          <h1>{{ copy.instructionHeader }}</h1>
          <p>{{ copy.instructionIntroText }}</p>
          <ul>
            <li v-for="point in copy.points" :key="point">{{ point }}</li>
          </ul>
          <p>{{ copy.instructionDisclaimer }}</p>
        </div>

        <div class="email-name form-input">
          <label for="name">{{ copy.nameLabel }}</label>
          <input id="name" type="text" v-model="name" :placeholder="copy.namePlaceholder" class="txt-input">
          <div class="pronoun-checkbox">
            <input type="checkbox" id="pronounBool" v-model="pronounBool">
            <label for="pronounBool">{{ copy.pronounLabel }}</label><br>
            <input class="txt-input" v-if="pronounBool" id="pronoun" type="text" v-model="pronoun"
              :placeholder="copy.pronounPlaceholder">
          </div>
        </div>
        <div class="email-title checkbox-div">
          <div class="title-checkbox">
            <input type="checkbox" id="titleBool" v-model="titleBool">
            <label for="titleBool">{{ copy.titleLabel }}</label>
          </div>
          <input class="txt-input" v-if="titleBool" id="title" type="text" v-model="title"
            :placeholder="copy.titlePlaceholder">
        </div>
        <div class="email-division checkbox-div">
          <div class="division-checkbox">
            <input type="checkbox" id="departmentBool" v-model="departmentBool">
            <label for="departmentBool">{{ copy.departmentLabel }}</label>
          </div>
          <input class="txt-input" v-if="departmentBool" id="department" type="text" v-model="department"
            :placeholder="copy.departmentPlaceholder">
        </div>
        <div class="office-phone form-input">
          <label for="officephone">{{ copy.officePhoneLabel }}</label>
          <input class="txt-input" type="text" id="officephone" v-model="phone" placeholder="Office phone number">
          <label for="officephonelabel">{{ copy.officePhoneLabelLabel }}</label>
          <input class="txt-input" type="text" v-model="phoneOffice" id="officephonelabel"
            placeholder="(ex. Office or O)">
        </div>
        <div class="additional-phone checkbox-div">
          <div class="phone-checkbox">
            <input type="checkbox" id="phone2" v-model="phone2">
            <label for="phone2">{{ copy.phone2Label }}</label><br>
          </div>
          <input class="txt-input" v-if="phone2" type="text" v-model="phone2Number" :placeholder="copy.phone2Placeholder">
          <input class="txt-input" v-if="phone2" type="text" v-model="phone2Text" placeholder="edit me">
          <div class="phone-checkbox">
            <input type="checkbox" id="phone3" v-model="phone3">
            <label for="phone3">{{ copy.phone3Label }}</label><br>
          </div>
          <input class="txt-input" v-if="phone3" type="text" v-model="phone3Number" placeholder="edit me">
          <input class="txt-input" v-if="phone3" type="text" v-model="phone3Text" placeholder="edit me">
          <div class="phone-checkbox">
            <input type="checkbox" id="phone4" v-model="phone4">
            <label for="phone4">{{ copy.phone4Label }}</label><br>
          </div>
          <input class="txt-input" v-if="phone4" type="text" v-model="phone4Number" placeholder="edit me">
          <input class="txt-input" v-if="phone4" type="text" v-model="phone4Text" placeholder="edit me">
        </div>
        <div class="email form-input">
          <label for="email">{{ copy.emailLabel }}</label>
          <input id="email" type="email" v-model="email" placeholder="first.last@company.com" class="txt-input">
        </div>
        <div class="address-input-div">
          <div class="checkbox-div">
            <div class="address-checkbox">
              <input type="checkbox" id="address" v-model="address">
              <label for="address">{{ copy.addressLabel }}</label>
            </div>
            <input class="txt-input" v-if="address" type="text" v-model="addressLine1" placeholder="edit me">
            <input class="txt-input" v-if="address" type="text" v-model="addressLine2" placeholder="address line 2">
            <input class="txt-input" v-if="address" type="text" v-model="addressLine3" placeholder="address line 3">
          </div>
        </div>
        <div class="checkbox-div">
          <div class="social-checkbox">
            <input type="checkbox" id="social" v-model="social">
            <label for="social">{{ copy.socialMediaLabel }}</label>
          </div>
        </div>
          <div class="checkbox-div">
          </div>
      </div>
      <div class="signature-area">
        <ImageView :name='name' :color='color' :pronoun='pronoun' :pronounBool='pronounBool' :title='title'
          :titleBool='titleBool' :departmentBool='departmentBool' :department='department' :phone='phone'
          :phoneOffice='phoneOffice' :phone2='phone2' :phone2Number='phone2Number' :phone2Text='phone2Text'
          :phone3='phone3' :phone3Number="phone3Number" :phone3Text="phone3Text" :phone4='phone4'
          :phone4Number="phone4Number" :phone4Text="phone4Text" :social='social' :email='email'
          :instructions='instructions' :imageBtnTxt="imageBtnTxt" :closeImageBtnTxt="closeImageBtnTxt"
          :pasteImageTxt="pasteImageTxt" :emailNote='emailNote' :address='address' :addressLine1="addressLine1"
          :addressLine2="addressLine2" :addressLine3="addressLine3" :logoPath="logoPath" />
      </div>
    </section>
  </div>
</template>

<script>

import ImageView from '@/components/ImageView'

export default {
  name: 'SignatureForm',
  components: {
    ImageView
  },
  data: function () {
    return {
      seen: false,
      color: 'gold',
      name: 'First M. Last',
      pronounBool: true,
      pronoun: '',
      title: 'Title',
      titleBool: true,
      departmentBool: true,
      department: 'Department',
      phone: '+1.123.456.7890',
      phone2: true,
      phone2Number: '+1.123.456.7890',
      phone2Text: 'C',
      phone3: false,
      phone3Number: '+1.123.456.7890',
      phone3Text: 'M',
      phone4: false,
      phone4Number: '+1.123.456.7890',
      phone4Text: 'H',
      email: 'first.last@vantor.com',
      social: true,
      emailNote: false,
      address: false,
      addressLine1: "Office address line 1",
      addressLine2: "Office address line 2",
      addressLine3: "Office address line 3",
      phoneOffice: 'O',
      instructions:
        "<div style='color: #8E0DD1; font-weight: bold; font-size: 18px; margin-bottom: 15px;'>Vantor Email Signature</div><ol style='margin: 0; padding-left: 20px;'><li>Please input your information into the form.</li><li>Copy the email signature and paste it into Outlook.</li><li>How to update in Outlook:<ul style='margin: 5px 0; padding-left: 20px;'><li>In the search bar, type and select \"Signature\" to format and add signature to all of your emails.</li></ul></li></ol><br><p style='margin: 10px 0 0 0;'>Detailed instructions can be found <a href='https://support.microsoft.com/en-us/office/create-and-add-an-email-signature-in-outlook-8ee5d4f4-68fd-464a-a1c1-0e1c80bb27f2' target='_blank' style='color: #8E0DD1;'>here</a>.</p>",
      imageBtnTxt: '',
      closeImageBtnTxt: "",
      pasteImageTxt: "",
      logoOptions: [
        {
          value: 'https://cdn.sanity.io/images/ava0h2e5/production/3421c27c050a50ebd09784e91019fa3e85935412-451x124.png',
          text: "Vantor",
        },
      ],
      logoPath: '',
    }
  },
  props: {
    copy: Object
  },
  mounted() {
    this.logoPath = this.logoOptions[0].value
  }
}
</script>

<style>
.signature-form {
  font-family: 'TWKEverett', 'Aptos', Arial, 'Open Sans', sans-serif;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.signature-form label {
  cursor: pointer;
}

header {
  color: white;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.content {
  display: flex;
  flex-direction: row;
  width: 80%;
}

.form-area {
  display: flex;
  flex-direction: column;
  background-color: #F8F6F0;
  align-items: center;
  padding: 25px;
}

.inline-modal {
  width: 300px;
  margin-bottom: 20px;
}

.form-input {
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
}

.checkbox-div {
  width: 300px;
  display: flex;
  flex-direction: column;
}

.radio-div {
  width: 300px;
  display: flex;
}

.radio-div label {
  margin-top: 3px;
}

.button-area {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
}

.info-btn {
  width: 50px;
  height: 35px;
  cursor: pointer;
}

.close-btn {
  width: 50px;
  height: 30px;
  cursor: pointer;
}

.button.modal-btn:hover {
  background-color: black;
  color: white;
}

input[type="checkbox"],
input[type="radio"] {
  margin-bottom: 10px;
}

select,
.txt-input {
  width: 300px;
  height: 40px;
  margin-bottom: 10px;
  background: white;
  font-size: 16px;
  color: #797979;
  font-family: 'TWKEverett', 'Aptos', Arial, 'Open Sans', sans-serif;
}

.txt-input {
  box-sizing: border-box;
  box-shadow: none;
  border: 1px solid #eee;
  border-top-width: 0;
  border-left-width: 0;
  border-right-width: 0;
  border-bottom: 2px solid #dedede;
  padding: 5px 10px;
}

::placeholder {
  color: #a3a3a3;
}

:-ms-input-placeholder {
  color: #a3a3a3;

}

::-webkit-input-placeholder {
  color: #a3a3a3;
}


label {
  text-align: left;
  font-size: 11px;
  text-transform: uppercase;
  color: #797979;
  margin-bottom: 5px;
}


@media(max-width: 860px) {
  .content {
    flex-direction: column;
    justify-content: center;
    width: 95%;
  }

  .form-area {
    width: 100%;
    padding: 20px;
  }

  .signature-area {
    display: flex;
    justify-content: center;
  }

}
</style>
